import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
    state: {
      user: false,
      showLoginDialog: false,
      isLoggedIn: false,
      btnLoginHidden:false,      loginUserHidden:true,

      showZhdjDialog:false,
      showLoginDialogAdmin: false,
      isLoggedInAdmin: false,
      btnLoginHiddenAdmin:false,
      loginUserHiddenAdmin:true,
      pwdDialogVisible:false,
      userid:0,
      useraccount:""
    },
    mutations: {
      setPwdDialogVisible(state, value) {
        state.pwdDialogVisible = value;
      },
      setShowLoginDialog(state, value) {
        state.showLoginDialog = value;
      },
      setLoggedIn(state, value) {
        state.isLoggedIn = value;
      },
      setShowLoginDialogAdmin(state, value) {
        state.showLoginDialogAdmin = value;
      },
      setLoggedInAdmin(state, value) {
        state.isLoggedInAdmin = value;
      },
        // // 登录
        // login(state, user) {
        //     state.user = user;
        //     localStorage.setItem("userInfo", user);
        // },
        // // 退出
        // logout(state, user) {
        //     state.user = "";
        //     localStorage.setItem("userInfo", "");
        // }
    },
    actions: {
      pwdDialogVisible({ commit }) {
        commit('pwdDialogVisible', true);
      },
      showLoginDialog({ commit }) {
        commit('setShowLoginDialog', true);
      },
      hideLoginDialog({ commit }) {
        commit('setShowLoginDialog', false);
      },
      loginSuccess({ commit }) {
        commit('setLoggedIn', true);
        commit('setShowLoginDialog', false);
      },
      logout({ commit }) {
        commit('setLoggedIn', false);
      },
      showLoginDialogAdmin({ commit }) {
        commit('setShowLoginDialogAdmin', true);
      },
      hideLoginDialogAdmin({ commit }) {
        commit('setShowLoginDialogAdmin', false);
      },
      loginSuccessAdmin({ commit }) {
        commit('setLoggedInAdmin', true);
        commit('setShowLoginDialogAdmin', false);
      },
      logoutAdmin({ commit }) {
        commit('setLoggedInAdmin', false);
      },
    },
    getters: {
      getPwdDialogVisible(state) {
        return state.pwdDialogVisible;
      },
      getShowLoginDialog(state) {
        return state.showLoginDialog;
      },
      getIsLoggedIn(state) {
        return state.isLoggedIn;
      },
      getShowLoginDialogAdmin(state) {
        return state.showLoginDialogAdmin;
      },
      getIsLoggedInAdmin(state) {
        return state.isLoggedInAdmin;
      },
    },
})



// WEBPACK FOOTER //
// ./src/vuex/store.js